<template>
  <span>
    <base-button
      :icon="isIcon"
      size="sm"
      :disabled="isReadOnly || isPartnerAccount"
      data-backdrop="static"
      data-keyboard=false
      data-toggle="modal"
      data-target="lineItemModal"
      :class="isIcon ? 'btn-link' : 'btn_extra_small btn_info white'"
      @click.native="viewItem"
    >
      <slot name="modal-link"></slot>
    </base-button>
    <modal  v-on:close="closeForm" :show.sync="showModal" modal-id="lineItemModal" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">LINE ITEM</h4>
      <hr />
      <div class="container">
        <label style="padding-top: 10px;">Class of Supply</label>
        <v-select
          :disabled="isReadOnly || isPartnerAccount"
          v-model="lineItem.stockClassId"
name="stockClass"
          :class="errors.has('stockClass') ? 'has-danger' : 'no'"
         :error="getError('stockClass')"
          v-validate="'required'"
          data-vv-as="Class of Supply"
          label="name"
          @input="stockClassOnChange"

          :reduce="(stockclass) => stockclass.stockClassId"
          :options="sortedStockClasses"
          placeholder="Select one"
        ></v-select> 
                  <span v-show="errors.has('stockClass')" class="error">
          {{ errors.first("stockClass") }}</span
        >
        <br />

        <label style="padding-top: 10px;">Sub Class</label>
        <v-select
          :disabled="isReadOnly || isPartnerAccount"
          v-model="lineItem.stockSubClassId"
          name="stockSubClass"
          :class="errors.has('stockSubClass') ? 'has-danger' : ''"
          :error="getError('stockSubClass')"
          label="name"
          :reduce="(subclass) => subclass.stockSubClassId"
          :options="stockSubClasses"
          placeholder="Select one"
        ></v-select>
        <span v-show="errors.has('stockSubClass')" class="error"
          >{{ errors.first("stockSubClass") }}
        </span>
        <br />
        <label style="padding-top: 10px;"> Stock No. & Description</label>
        <base-input
          :disabled="isReadOnly || isPartnerAccount"
          v-model="lineItem.stockDescription"
          name="stockDescription"
        ></base-input>

        <label style="padding-top: 10px;">Unit Of Measure</label>
        <v-select
          :disabled="isReadOnly || isPartnerAccount"
          v-model="lineItem.unitMeasureId"
          :class="errors.has('unitMeasure') ? 'has-danger' : ''"
          label="name"
          name="unitMeasure"
          v-validate="'required'"
          data-vv-as="Unit of Measure"
          :error="getError('unitMeasure')"
          :reduce="(measure) => measure.id"
          :options="unitMeasures"
          placeholder="Select one"
        ></v-select>
        <span v-show="errors.has('unitMeasure')" class="error"
          > {{ errors.first("unitMeasure") }}
        </span>
        <br />

        <label style="padding-top: 10px;">QTY Requested</label>
        <base-input
          :disabled="isReadOnly || isPartnerAccount"
          type="currency"
          min="0"
          max="800000"
          name="requestedQuantity"
          data-vv-as="Requested Quantity"
          v-model="lineItem.requestedQuantity"
          :class="errors.has('requestedQuantity') ? 'has-danger' : 'no'"  
          v-on:blur="quantityFormatter"
          @focus="backToInput2"  
          v-validate="userValidations.requestedQuantity"
          @keypress="filterNumber($event)"
          @paste="onPaste"
        ></base-input>
         <span v-show="errors.has('requestedQuantity')" class="error has-danger"
          > {{ errors.first("requestedQuantity") }}
        </span>
        <br>
        <label style="padding-top: 10px;">Unit Price</label>
        <base-input
          :disabled="isReadOnly || isPartnerAccount"
          type="currency"
          max="100000000"
          name="unitPrice"
          data-vv-as="Unit Price"
          v-model="lineItem.unitPrice"
           :class="errors.has('unitPrice') ? 'has-danger' : 'no'" 
          v-on:blur="currencyFormatter"
          @focus="backToInput" 
          v-validate="userValidations.unitPrice"
          @paste="onPaste"
          @keypress="filterNumber($event)"
        ></base-input>
          <span v-show="errors.has('unitPrice')" class="error has-danger"
          > {{ errors.first("unitPrice") }}
        </span>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="closeForm"
          >
            Close
          </base-button>
          <base-button
            :disabled="isReadOnly || isPartnerAccount || isSaving"
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="submit"
          >
            {{isNew? 'Save' : 'Update' }}
          </base-button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BaseButton, Modal } from "@/components";
import Util from "@/util/util";

export default {
  name: "line-item-modal",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    showLineItemModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modals: {
        classic: false,
      },
      priceInput: null,
      isSaving: false,
      quantityInput: null,
      userValidations: {
        requestedQuantity: {
          required: true,
          min_currency: 0.01,
        },
        unitPrice: {
          required: true,
          min_currency: 0.01,
        }
      },
    };
  },
  components: {
    BaseButton,
    Modal,
  },
  computed: {
    ...mapGetters({
      lineItem: "lineItem/lineItem",
      lineItems: "lineItem/lineItems",
      stockClasses: "stockClass/stockClasses",
      stockSubClasses: "stockClass/stockSubClasses",
      unitMeasures: "unitMeasure/unitMeasures",
      orderMetadata: "orderMetadata/orderMetadata",
      lineItemErrors: "lineItem/lineItemErrors",
      isPartnerAccount: "authentication/isPartnerAccount"
    }),
    stockSubClassRule() {
      return this.stockSubClasses.length > 0 ? "required" : "";
    },
    showModal() {
      return this.showLineItemModal || this.modals.classic;
    },
    sortedStockClasses() {
      return this.stockClasses.slice().sort((a, b) => { return a.rankOrder - b.rankOrder; });

  },
},
  mounted() {
    this.errors.clear();
    this.getLineItems(this.$route.params.id);
    this.getUnitMeasures();
    this.getStockClasses();
  },
  methods: {
    ...mapActions({
      getLineItems: "lineItem/getLineItems",
      getLineItem: "lineItem/getLineItem",
      getLineItemStatus: "lineItem/getLineItemStatus",
      clearStockSubClass: "lineItem/clearStockSubClass",
      saveLineItem: "lineItem/saveLineItem",
      getStockClasses: "stockClass/getStockClasses",
      getStockSubClasses: "stockClass/getStockSubClasses",
      getUnitMeasures: "unitMeasure/getUnitMeasures",
      getOrderByStatus: "orders/getOrderByStatus",
      clearLineItem: "lineItem/clearLineItem"
    }),
    currencyFormatter(event) {
      this.priceInput = (event.target.value)
      if(this.priceInput){
       let decimalPart = this.priceInput.split('.')[1];
      let hasMoreThanTwoDecimalPlaces = decimalPart && decimalPart.length > 2;
     let hasOnlyZerosAfterDecimal = decimalPart && /^0+$/.test(decimalPart);
      let formattedValue
      if(hasOnlyZerosAfterDecimal){
  formattedValue = parseFloat(this.priceInput).toFixed(2);
      }
     else if(hasMoreThanTwoDecimalPlaces){
        formattedValue = this.priceInput.toString();

      }else if(decimalPart && decimalPart.length > 2){
            formattedValue = this.priceInput.toString();
      }else{
            formattedValue = parseFloat(this.priceInput).toFixed(2);
      
          }
      const parts = formattedValue.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.lineItem.unitPrice = parts.join("."); 
      }
    },
     onPaste(e) {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    if (pasted.includes(',')) {
      e.preventDefault();
      this.$toast.error('Invalid Input')
    }
    
  },
    quantityFormatter(event){
      this.quantityInput = event.target.value;
      if(this.quantityInput){
      let decimalPart = this.quantityInput.split('.')[1];
      let hasMoreThanTwoDecimalPlaces = decimalPart && decimalPart.length > 2;
     let hasOnlyZerosAfterDecimal = decimalPart && /^0+$/.test(decimalPart);
      let formattedValue
      if(hasOnlyZerosAfterDecimal){
  formattedValue = parseFloat(this.quantityInput).toFixed(2);
      }
     else if(hasMoreThanTwoDecimalPlaces){
        formattedValue = this.quantityInput.toString();

      }else if(decimalPart && decimalPart.length > 2){
            formattedValue = this.quantityInput.toString();
      }else{
            formattedValue = parseFloat(this.quantityInput).toFixed(2);
      
          }
      const parts = formattedValue.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.lineItem.requestedQuantity = parts.join("."); 
     }
     },
     backToInput2(event){
      if(this.quantityInput){
        this.lineItem.requestedQuantity =  this.quantityInput
      }else{
        this.lineItem.requestedQuantity = event.target.value
      }
    },
    filterNumber(evt) {
      // only allow number
      // to prevent extra chars, use event.keyCode === <charCode> || <repeat>
        evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      }

      // Prevent more than one decimal point
if (charCode === 46 && evt.target.value.includes(".")) {
  evt.preventDefault();
  return;
}

// Limit to 10 digits after the decimal point
if (evt.target.value.includes(".")) {
  var decimalPart = evt.target.value.split(".")[1];
  if (decimalPart && decimalPart.length >= 10) {
    evt.preventDefault();
    return;
  }
}
        return true;
      
    },
    backToInput(event){
      if(this.priceInput){
        this.lineItem.unitPrice =  this.priceInput
      }else{
        this.lineItem.unitPrice =event.target.value
      }
    },
    closeForm() {
      this.clearLineItem();
      this.errors.clear();
      this.modals.classic = false;
      this.$emit('modal-closed');
      this.quantityInput = '';
      this.priceInput = '';
    },
    setItemNumber() {
      let ctx = this;
      //if its  new genrate new item number
      // otherwise get the current postion
      // the add 1 to convert from an index value to an acual number that makes sense to user
      if (ctx.isNew) {
         ctx.lineItem.itemNumber = ctx.lineItems && ctx.lineItems.length > 0 ? Math.max.apply(Math, ctx.lineItems.map(lineItem => lineItem.itemNumber)) + 1 : 1;
      }
    },
    showLineItemErrors (response) {
      if(this.lineItemErrors.length > 0 ) {
        this.lineItemErrors.forEach(error => this.$toast.error(error));
      }
    },
    async validateAllWrapper() {
      let ctx = this;
      let result = await this.$validator.validateAll().then(async(result)=>{
        if(result) {
      this.isSaving = true;

        try{
          ctx.setItemNumber();
          let response = await ctx.saveLineItem(ctx.$route.params.id);
          ctx.getLineItems(ctx.$route.params.id);
          let message = response.data;
          await ctx.getLineItemStatus(ctx.$route.params.id);
          ctx.showLineItemErrors(message);
          ctx.getOrderByStatus({
            orderStatus: ctx.orderMetadata.orderStatus,
            id: ctx.$route.params.id,
          });
      this.isSaving = false;
          this.closeForm();
        } catch(error) {
          this.isSaving = false
          this.$toast.error(error.response.data);
        }
         
      } else {
        const errors =  this.errors.all()
        this.$toast.error( errors.length > 1 ? 'Please complete required fields': errors[0] == 'Unit Price must be at least 0.01' ? errors[0] : errors[0] == 'Requested Quantity must be at least 0.01' ? errors[0] : errors[0]); 
      }
      });

    
    },
    submit(e) {
      (async () => await this.validateAllWrapper())();
      this.quantityInput = ''
      this.priceInput = ''
    
    },
    getError(fieldName) {
      return Util.transformValidationText(this.errors.first(fieldName));
    },
    stockClassOnChange(value) {
      this.clearStockSubClass();
      this.getStockSubClasses(value);
    },
   viewItem() {
     let ctx = this;
     this.isSaving = false;      
      this.errors.clear();
      ctx.getUnitMeasures();
      ctx.getStockClasses();
    
      if(ctx.isNew) {
        ctx.modals.classic = true;
      }
      else{
        ctx.getLineItem(ctx.id);
      }
    },
  },
};
</script>

<style>
.has-danger .vs__dropdown-toggle {
  border-color: #ec250d !important;
}

.error {
  color: #ec250d;
  font-size: 0.75rem;
}
</style>
